import { css } from "@emotion/react";
import colors from "@moodys/mdc-frontend.theming.colors";

export const socialLinksStyles = {
  container: css({
    display: "flex",
    gap: 8,
  }),
  icon: css({
    background: colors.globalWhite,
    color: colors.globalBlue800,
    "&:hover": {
      background: colors.globalBlue200,
    },
  }),
};
